export const LOCK_STATUS_DASHBOARD = "LOCK_STATUS_DASHBOARD";
export const DELETE_MODEL_AVAILABILITY = "DELETE_MODEL_AVAILABILITY";
export const DELETE_MATERIAL_AVAILABILITY = "DELETE_MATERIAL_AVAILABILITY";
export const DELETE_SERVICE = "DELETE_SERVICE";
export const DELETE_AVIALABLE_LOCALIZATION = "DELETE_AVIALABLE_LOCALIZATION";
export const DELETE_DEFAULT_LOCALIZATION = "DELETE_DEFAULT_LOCALIZATION";
export const DELETE_TOF_PROGRAM_MANAGEMENT = 'DELETE_TOF_PROGRAM_MANAGEMENT';
export const DELETE_LOC_CHOICEID = 'DELETE_LOC_CHOICEID';
export const DELETE_LOC_MAPPING = 'DELETE_LOC_MAPPING';
export const DATA_TRANSPORT_AND_COMPLETE = "DATA_TRANSPORT_AND_COMPLETE";
export const MODULE_WISE = 'moduleWise';
export const DASHBOARD_DT = 'dashboard_DT';
export const MODEL_DT = 'model_DT';
export const CATEGORY_FILTER = "CATEGORY_FILTER";


// Model Availability
export const MODEL_AVAILABILITY = "MODEL_AVAILABILITY";
export const COUNTRY_LIST = "COUNTRY_LIST";
export const BUSINESS_MODEL = "BUSINESS_MODEL";
export const REGION_DROPDOWN = "REGION_DROPDOWN";
export const FILTER_OCPLC_EDIT_DASHBOARD = "FILTER_OCPLC_EDIT_DASHBOARD";
export const FILTERED_BY_LOCK_STATUS = "FILTERED_BY_LOCK_STATUS";
export const CLEAR_OCPLC_DASHBOARD_FILTERS = "CLEAR_OCPLC_DASHBOARD_FILTERS";
export const CLEAR_OCPLC_FILTERS = "CLEAR_OCPLC_FILTERS";
export const FILTER_BY_STATUS = 'FILTER_BY_STATUS';
export const HIDE_LABELS = ["Product Family", "Status"];
export const VERSION_0002 = '0002';
export const VERSION_0003 = '0003';
export const PLC_ADMIN = 'plc_admin';
export const PLC_WW = 'plc_ww';
export const PLC_REGIONAL = 'plc_regional';
export const PLC = 'plc';
export const PLC_AP = 'plc_ap';
export const PLC_LA = 'plc_la';
export const PLC_NA = 'plc_na';
export const PLC_EU = 'plc_eu';
export const TOF_AUDIT_TRAIL = "TOF_AUDIT_TRAIL"
export const UPDATE_MODEL_AVAILABILITY = "UPDATE_MODEL_AVAILABILITY";
export const UPDATE_MATERIAL_AVAILABILITY = "UPDATE_MATERIAL_AVAILABILITY";
export const UPDATE_SERVICE_AVAILABILITY = "UPDATE_SERVICE_AVAILABILITY"
export const CREATE_EXISTING_AVAILABILITY = "CREATE_EXISTING_AVAILABILITY";
export const PRODUCT_GROUP_DROPDOWN = "PRODUCT_GROUP_DROPDOWN";
export const TOF_PROGRAM_MANAGEMENT_TABLE = "TOF_PROGRAM_MANAGEMENT_TABLE";
export const FILTER_OCPLC_KMAT_FOR_PG = "FILTER_OCPLC_KMAT_FOR_PG";
export const UPLOAD_LAND_D_FILE = "UPLOAD_LAND_D_FILE";
export const BULK_DOWNLOAD_UPLOAD_FILE = "BULK_DOWNLOAD_UPLOAD_FILE";
export const ROLE_FROM_DROPDOWN = 'OCPLC Read Only';
export const OCPLC_ADMIN = 'OCPLC Admin';
export const UPDATE_DEFAULT_LOCALIZATION = "UPDATE_DEFAULT_LOCALIZATION"
export const UPDATE_AVAILABILITY_LOCALIZATION = "UPDATE_AVAILABILITY_LOCALIZATION"
export const GET_DEFAULT_FEATURE_DROPDOWN = "GET_DEFAULT_FEATURE_DROPDOWN"
export const GET_DEFAULT_FEATURE_VALUE_DROPDOWN = "GET_DEFAULT_FEATURE_VALUE_DROPDOWN"
export const GET_PARAMETERS_DROPDOWN = "GET_PARAMETERS_DROPDOWN"
export const UPDATE_TOF_PROGRAM_MANAGEMENT = "UPDATE_TOF_PROGRAM_MANAGEMENT"
export const GET_LOCALIZATION_CHOICE_KEY = "GET_LOCALIZATION_CHOICE_KEY"
export const GET_LOCALIZATION_CHOICE_NAME = "GET_LOCALIZATION_CHOICE_NAME"
export const GET_LOCALIZATION_CHOICE_VALUE = "GET_LOCALIZATION_CHOICE_VALUE"
export const UPDATE_LOC_CHOICEID = "UPDATE_LOC_CHOICEID"
export const GET_PARAMETERS_LOCALIZATION_DROPDOWN = "GET_PARAMETERS_LOCALIZATION_DROPDOWN"
export const UPDATE_LOC_MAPPING = "UPDATE_LOC_MAPPING"
export const GET_REGIONAL_CHECKBOXES = "GET_REGIONAL_CHECKBOXES"
export const RELEASELOCK = "RELEASELOCK"

export const REGIONS = ['AP', 'EU', 'LA', 'NA'];

export const REGION_AP = 'AP';
export const REGION_LA = 'LA';
export const REGION_NA = 'NA';
export const REGION_EU = 'EU';
export const REGION_WW = 'WW';

export const MATERIAL_AVAILABILITY_TABLE = 'MATERIAL_AVAILABILITY_TABLE';
export const FACTORY_SERVICES_TABLE = 'FACTORY_SERVICES_TABLE';
export const PARAMETERS_TABLE = 'PARAMETERS_TABLE';
export const LOCALIZATION_MAPPING_TABLE = 'LOCALIZATION_MAPPING_TABLE';
export const LOCALIZATION_CHOICE_ID_TABLE = 'LOCALIZATION_CHOICE_ID_TABLE';
export const OCPLC_CONFIGURATION_TABLE = 'OCPLC_CONFIGURATION_TABLE';
export const LOCALIZATION_DEFAULT_TABLE = 'LOCALIZATION_DEFAULT_TABLE';
export const LOCALIZATION_AVAILABILITY_TABLE = 'LOCALIZATION_AVAILABILITY_TABLE';
export const MATERIAL_AVAILABILITY = 'Material Availability';
export const FACTORY_SERVICES = 'Factory Services';
export const MODEL_AVAILABILITY_TABLE = 'Model Availability';
export const DEFAULT_LOC = 'Default Localization';
export const LOC_AVAILABILITY = 'Available Localization';
export const TOF_PROGRAM_MANAGEMENT = 'TOF Program Management';
export const LOC_MAPPING = 'Localization Mapping';
export const LOC_CHOICE_ID = 'Localization Choice ID Customization';

export const ROLE_DETAILS_MAP = {
    'OCPLC Admin': { region: 'WW', table: MODEL_AVAILABILITY_TABLE },
    'OCPLC KE': { region: 'WW', table: MATERIAL_AVAILABILITY },
    'OCPLC KE - AP': { region: 'AP', table: MATERIAL_AVAILABILITY },
    'OCPLC KE - NA': { region: 'NA', table: MATERIAL_AVAILABILITY },
    'OCPLC KE - EU': { region: 'EU', table: MATERIAL_AVAILABILITY },
    'OCPLC KE - LA': { region: 'LA', table: MATERIAL_AVAILABILITY },
    'OCPLC Regional': { region: 'WW', table: FACTORY_SERVICES },
    'OCPLC Read Only': { region: 'WW', table: MATERIAL_AVAILABILITY },
};
export const ROLE_DETAILS_MAP_TOF = {
    'OCPLC Admin': { region: 'AP', table: TOF_PROGRAM_MANAGEMENT },
    'OCPLC KE': { region: 'AP', table: TOF_PROGRAM_MANAGEMENT },
    'OCPLC KE - AP': { region: 'AP', table: TOF_PROGRAM_MANAGEMENT },
    'OCPLC KE - NA': { region: 'NA', table: TOF_PROGRAM_MANAGEMENT },
    'OCPLC KE - EU': { region: 'EU', table: TOF_PROGRAM_MANAGEMENT },
    'OCPLC KE - LA': { region: 'LA', table: TOF_PROGRAM_MANAGEMENT },
    'OCPLC Regional': { region: 'AP', table: TOF_PROGRAM_MANAGEMENT },
    'OCPLC Read Only': { region: 'AP', table: TOF_PROGRAM_MANAGEMENT },
    };


export const CREATE_AVAILABILITY = "CREATE_AVAILABILITY"
export const GET_PRODUCT_LINE = "GET_PRODUCT_LINE"
export const GET_OCPLC_CHOICES ="GET_OCPLC_CHOICES"
export const LOAD_COUNT_DT="LOAD_COUNT_DT"
export const ROLE_NAME_FOR_ADMIN = "OCPLC Admin"
export const ROLE_NAME_FOR_KE = "OCPLC KE"
export const ROLE_NAME_FOR_KE_AP = "OCPLC KE - AP"
export const ROLE_NAME_FOR_KE_NA = "OCPLC KE - NA"
export const ROLE_NAME_FOR_KE_EU = "OCPLC KE - EU"
export const ROLE_NAME_FOR_KE_LA = "OCPLC KE - LA"
export const OCPLC_REGIONAL = 'OCPLC Regional';
export const OCPLC_READ_ONLY = 'OCPLC Read Only';
export const OCPLC_KE_OTHER_REGIONAL = 'OCPLC KE -';

export const REQUIRED_FIELDS = ['PRODUCT_LINE', 'PRODUCT_FAMILY', 'PRODUCT_DESC', 'BUSINESS_MODEL', 'START_DATE', 'END_DATE', 'COMMENT'];
export const REQUIRED_FIELDS_MATERIAL = ['PRODUCT_LINE', 'PRODUCT_FAMILY', 'BUSINESS_MODEL', 'CHOICE_ID', 'LOCALIZATION', 'MATERIAL', 'START_DATE', 'END_DATE', 'COMMENT'];
export const REQUIRED_FIELDS_DEFAULT_LOC = ['COUNTRY', 'PRODUCT_FAMILY', 'LOC_FEATURE', 'LOC_FEATURE_VALUE', 'COMMENT'];
export const REQUIRED_FIELDS_FOR_TOF_PROGRAM = ['PRODUCT_GROUP', 'REGION', 'PARAMETER','PARAMETER_NAME','PARAMETER_VALUE'];
export const OCPLC_DROPDOWN = ['Role', 'Version', 'Table', 'Region', 'Product Group', 'Product Family', 'Tab Category'];
export const PRODUCT_FAMILY_PATTERN = /^[a-zA-Z0-9]{6}-999$/;

export const DASHBOARD_TITLE = "OCPLC Dashboard";
export const MODULE_TYPE = "ModelAvailability"
export const DUMMY_DATE = '9999-01-01';
export const INVALID_COMMENTS = "Record is changed by WW user"
export const DISABLE_WW_DATES = "Record is changed by:MS4_PLC_SYNC";
export const DISABLE_LOC = "COMMENT-TO-BLOCK-EDITING-FROM-UI";
export const INVALID_COMMENTS_FOR_MATERIAL = "COMMENT-TO-BLOCK-EDITING-FROM-UI"
export const DOWNLOAD_ALL = "Download All Tables";
export const DATA_TRANSPORT = "dataTransport";
export const COMPLETE = "complete";

export const RESTRICTED_STATUSES_DATA_TRANSPORT = ['M', 'V', 'E'];
export const RESTRICTED_STATUSES_COMPLETE = ['V', 'P', 'E'];
export const RESTRICTED_STATUSES_ADMIN_DATA_TRANSPORT = ['M', 'E'];
export const RESTRICTED_STATUSES_ADMIN_COMPLETE = ['E','V'];

export const DT_MESSAGES = {
    CONFIRMATION_TITLE: "Confirmation",
    CONFIRMATION_CONTENT: "Are you sure you want to perform this action?",
    LOAD_COUNT_EXCEEDED_CONTENT: (loadCount) => `You cannot select more than ${loadCount} items for Data Transport`,
    RESTRICTED_STATUS_DATA_TRANSPORT: "Data transport is allowed only 'P' status. Please update the status to proceed.",
    RESTRICTED_STATUS_COMPLETE: "Complete is allowed only for 'M' status. Please update the status to proceed.",
    SELECT_TABLE_TITLE: "Select Table for Data Transport",
};

export const COMPLETE_WARNING_MESSAGE = "This record will be set as Regional Locked.Other existing related records will also be set to Regional Locked status."

export const SPINNER_MESSAGE = "Processing, please wait…";

export const MATERIAL="Material"
export const SERVICE="Service"

export const ROLE_REGION_MAP = {
  plc_ap: "AP",
  plc_la: "LA",
  plc_na: "NA",
  plc_eu: "EU",
};

export const LOAD_COUNT = '5';

export const REGION_OPTIONS = [REGION_WW, ...REGIONS].map((region) => ({
  value: region,
  label: region,
}));

export const PRODUCT_OPTIONS = [
  { label: "DT", value: "COMMDT" },
  { label: "NB", value: "COMMNB" },
  { label: "WS", value: "COMMWS" },
  { label: "RP", value: "COMMRP" },
  { label: "ZB", value: "COMMZB" },
  { label: "TC", value: "COMMTC" },
];

export const ROLE_REGION_MAP_BULK_UPLOAD  = {
  plc_admin: {
    region: ['WW', 'AP', 'NA', 'EU', 'LA'],
  },
  plc: {
    region: ['WW'],
  },
  plc_ap: {
    region: ['AP'],
  },
  plc_na: {
    region: ['NA'],
  },
  plc_eu: {
    region: ['EU'],
  },
  plc_la: {
    region: ['LA'],
  },
};

export const ALL_REGIONS = ['WW', 'AP', 'NA', 'EU', 'LA'];